import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Credentials.css';
import CommonFormFields from '../../Forms/CommonFormFields';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { userCredentials } from '@constants/index';
import BadgesComponent from '@components/common/Badges';
import Button from '@components/common/Button';
import endpoints from '@config/endpoints';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '../../../utils/base64Utils';
import Auth from '../../../utils/auth';
import axios from '../../../utils/axiosExt';
interface newUserProps {
    user?:any;
    page?: string;
    flow?: string;
}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?:any,
  code?:any,
  compositeRoleId?:any,
}

export interface formStateType {
  [key: string]: objectType
}

interface formDataType {
  [key: string]: any;
}

const Credentials: React.FC<newUserProps> = ({page,user,flow}) => {
    const { id } = useParams(); 
    const navigate = useNavigate();
    const [formState, setFormState] = useState<formStateType>({
        userName: {
          isError: false,
          message: '',
          isDisable: false,
          value: user?.mob,
        },
        passwordChange: {
          isError: false,
          message: '',
          isDisable: false,
          value: '',
        },
        passwordReset: {
          isError: false,
          message: '',
          isDisable: false,
          value: false,
        }
       
      });  
      const [formData,setFormData]=useState<any>(userCredentials);
      const handleFormChange = (value: string | boolean, key: string,id?:any,option?:any,code?:any) => {
          setFormState((prevState: any) => ({
            ...prevState,
            [key]: {
              ...prevState[key],
                value: value,
                isError: false,
                message: '',
            },
          }));
        }
        const handleClose=()=>{
            navigate(-1);
        }
        const handleSave=async ()=>{
            const formStateTemp = {
                ...formState
              };
              const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,14}$/;
              let isFormError = false;
              Object.keys(formStateTemp).map((item) => {
                if (item === 'passwordChange') {
                  if (!formStateTemp.passwordChange.value) {
                    isFormError = true;
                    formStateTemp.passwordChange.isError = true;
                    formStateTemp.passwordChange.message = 'Password cannot be kept blank. Enter a valid Password.';
                  }
                  else if (!regex.test(formStateTemp.passwordChange.value)) {
                    isFormError = true;
                    formStateTemp.passwordChange.isError = true;
                    formStateTemp.passwordChange.message = "Password must be of 8 to 14 characters, have atleast one capital, one small, one digit and one special character(@$!%*?&)";
                  }
                }
              })
              setFormState(formStateTemp);
              if(isFormError===false){
                const data={
                    userName:formState.userName.value,
                    password:formState.passwordChange.value,
                    changePassword:formState.passwordReset.value
                }
                try{
                  const encodedNumber = encodeWithKeyAndShift(JSON.stringify(data));
                  const response = await axios.post(`${endpoints.unlockingUser}`, {data:encodedNumber}, Auth.loggedInWithJSON());
                  const decodedData = JSON.parse(decodeWithKeyAndShift(response?.data?.data?.data));
                  if(decodedData[0].auth_status === 'SAME_AS_LAST_PASSWORD'){
                    toast.error("The new password cannot be the same as the existing password.", {
                      position: "top-center"
                    });
                  }else{
                    toast.success("Successfully unlocked User.", {
                      position: "top-center"
                    });
                   navigate(-1);
                  }
                }
                catch(error:any){
                    toast.error("Failed to unlock User.", {
                        position: "top-center"
                      });
                }
              }
           
        }
  return (
    <>
    <BadgesComponent
        className="over-badge"
        badgeName="Credentials"
        variant="primary-1"
        badgeType="case5"
      />
   
    <div className="credentials_page_unlocking">
      <form className="form_container_credentials_details">
        <CommonFormFields
          formData={formData}
          formState={formState}
          handleFormChange={handleFormChange}
        />
      </form>
    </div>
    <div className='credentials_buttons_close_save'>
            <Button
              onClick={handleSave}
              disabled={false}
              id=""
              buttonName={'Save'}
              colorType={'primary'}
              icon={''}
              iconPosition={'left'}
            />
             <Button
              onClick={handleClose}
              disabled={false}
              id=""
              buttonName={'Cancel'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
            
    </div>
   
  </>
  );
};
export default Credentials;
